module.exports = __webpack_public_path__ + "plp/shop-women.d7ac13.jpg";